import { render } from "./WhaleRichView.vue?vue&type=template&id=c92787c6&scoped=true"
import script from "./WhaleRichView.vue?vue&type=script&lang=js"
export * from "./WhaleRichView.vue?vue&type=script&lang=js"

import "./WhaleRichView.vue?vue&type=style&index=0&id=c92787c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92787c6"]])

export default __exports__